<template>
  <Breadcrumbs
      title="Item Price History"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Items', path: '/items' },
      { label: 'Item Price History', path: '/item-price-history' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <itemPriceHistory />
    </div>
  </div>
</template>

<script>
import itemPriceHistory from './item_price_history_form.vue'
export default {
  name: 'indexList',
  components: {
    itemPriceHistory,
  },
}
</script>
